import axios from "axios";
import axiosClient from "./axiosClient";

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) throw new Error("No refresh token available.");

  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/token/refresh/`,
    { refresh: refreshToken }
  );

  localStorage.setItem("access_token", response.data.access);
};

export const logoutUser = async () => {
  // 1) pull the refresh token
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) {
    console.warn("No refresh token found when logging out");
  }

  try {
    // 2) send it in the body to /user/logout/ endpoint
    await axiosClient.post("/user/logout/", {
      refresh_token: refreshToken,
    });
  } catch (error) {
    // It’s fine if the token is already blacklisted or the server 400s.
    console.warn("Logout endpoint error (ignored):", 
    error.response?.data?.message || error.message);
  } finally {
    // 3) clear all client‑side state no matter what
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_id");
  }
};
